import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Alert } from 'react-bootstrap';
import { getSettings, updateSettings } from '../services/api';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const SettingsPage = () => {
  const { isAdmin } = useAuth();
  const [preloadVideo, setPreloadVideo] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let active = true;
    getSettings()
      .then((res) => { if (active) setPreloadVideo(!!res.data.preload_video); })
      .catch((err) => { if (active) setError(`โหลดการตั้งค่าไม่สำเร็จ: ${err.response?.data?.detail || err.message}`); })
      .finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; };
  }, []);

  const handleToggle = async (e) => {
    const next = e.target.checked;
    setPreloadVideo(next);
    setSaved(false);
    setError(null);
    setIsSaving(true);
    try {
      const res = await updateSettings({ preload_video: next });
      setPreloadVideo(!!res.data.preload_video);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      // Revert the toggle if the save failed.
      setPreloadVideo(!next);
      setError(`บันทึกไม่สำเร็จ: ${err.response?.data?.detail || err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center">
        <LoadingSpinner />
        <p>กำลังโหลดการตั้งค่า...</p>
      </div>
    );
  }

  return (
    <div className="settings-page">
      <Link to="/">&laquo; Back to Video List</Link>
      <h2 className="mt-3">การตั้งค่า</h2>

      {error && <Alert variant="danger">{error}</Alert>}
      {saved && <Alert variant="success">บันทึกการตั้งค่าแล้ว</Alert>}
      {!isAdmin && <Alert variant="info">เฉพาะผู้ดูแลเท่านั้นที่แก้ไขการตั้งค่าได้</Alert>}

      <div className="card p-3 mt-3" style={{ maxWidth: '640px' }}>
        <Form.Check
          type="switch"
          id="preload-video-switch"
          checked={preloadVideo}
          onChange={handleToggle}
          disabled={isSaving || !isAdmin}
          label="โหลดวิดีโอทั้งหมดก่อนเริ่มอัด (ป้องกันวิดีโอกระตุกทำให้ไทม์โค้ดเพี้ยน)"
        />
        <Form.Text className="text-muted mt-2">
          เมื่อเปิด: หน้าอัดจะดาวน์โหลดวิดีโอทั้งไฟล์ก่อน แล้วค่อยให้เริ่มอัดได้
          ทำให้วิดีโอไม่กระตุกระหว่างอัด และมาร์กเกอร์เสียง (play/pause/seek) ตรงกับเวลาในวิดีโอ
          ข้อเสียคือต้องรอโหลดก่อนเริ่มอัด และใช้กับวิดีโอที่โฮสต์บน S3 เท่านั้น (ไม่รวม Google Drive)
        </Form.Text>
      </div>

      {isSaving && <div className="mt-2"><LoadingSpinner small /> กำลังบันทึก...</div>}
    </div>
  );
};

export default SettingsPage;
